import { PageRoutes } from "Routes";
import "./App.css";

function App() {
  return <PageRoutes />;
}

export default App;
